import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { DonhangsanphamAction } from 'src/actions/donhangsanpham.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Select,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
} from 'src/utils/constants';

const CreateEditDialog = (props) => {
    const dispatch = useDispatch()
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.donhangsanpham)
    const [phi, setPhi] = useState("")
    const [thuc_thu, setThucThu] = useState("")
    const [ghi_chu_don_hang, setGhiChuDonHang] = useState("")

    const danhSachLoaiSim = SIM_TYPE_LIST_OBJ;

    useEffect(() => {
        if (items.length > 0) {
            return;
        }
    }, [])

    useEffect(() => {
        if (props.type === 'EDIT') {
            if (selected) {
                setPhi(selected.phi)
                setThucThu(selected.thuc_thu)
                setGhiChuDonHang(selected.ghi_chu_don_hang)
            }
        }
    }, [selected])

    const onPressPositive = () => {
        if (props.type === 'EDIT') {
            dispatch(DonhangsanphamAction.update(selected.id, {
                phi,
                thuc_thu, 
                ghi_chu_don_hang,
            }))
        } else {
            dispatch(DonhangsanphamAction.create({ 
                phi,
                thuc_thu,
                ghi_chu_don_hang,
            }))
        }
        resetState();
        props.handleClose();
    }

    const resetState = () => {
        setPhi("");
        setThucThu("");
        setGhiChuDonHang("")
    }

    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
            <DialogContent style={{ width: 600, paddingTop: 20 }}>
                <Grid
                    container
                    spacing={3}
                >
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Phí"
                            name="phi"
                            onChange={(e) => setPhi(e.target.value)}
                            value={phi}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Thực thu"
                            name="thuc_thu"
                            onChange={(e) => setThucThu(e.target.value)}
                            value={thuc_thu}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Ghi chú"
                            name="ghi_chu"
                            onChange={(e) => setGhiChuDonHang(e.target.value)}
                            value={ghi_chu_don_hang}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Huỷ</Button>
                <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
            </DialogActions>
        </Dialog >
    );
}

export default CreateEditDialog;